/* 
    public function balance_payments() {
        $dateFrom = $this->postParams["date_from"];
        $dateTo = $this->postParams["date_to"];

        if(!strlen($dateFrom) && !strlen($dateTo)) {
            throw new Exception("You must specify atleast a date from or date to value");
        }

        $sql = "
        SELECT 
        
        C.id, C.email, O.id, CR.code, CR.startDate, CR.endDate, O.totalDue
        
        FROM OrderBoughtProduct OBP 
        
        -- join on the order
        LEFT JOIN Core_Relationship L5 ON 
        L5.leftClassName = ('Order') AND 
        L5.rightClassName = ('OrderBoughtProduct') AND 
        L5.rightInstanceId = OBP.id AND 
        L5.leftToRightProperty = ('boughtProducts')
        
        LEFT JOIN `Order` O ON 
        O.id = L5.leftInstanceId
        
        -- join on the customer
        LEFT JOIN Core_Relationship L1 ON 
        L1.leftClassName = ('OrderBoughtProduct') AND 
        L1.leftInstanceId = OBP.id AND 
        L1.rightClassName = ('Customer') AND 
        L1.leftToRightProperty = ('customer')
        
        LEFT JOIN Customer C ON 
        C.id = L1.rightInstanceId
        
        -- join on the classroom
        LEFT JOIN Core_Relationship L2 ON 
        L2.leftClassName = ('OrderBoughtProduct') AND 
        L2.leftInstanceId = OBP.id AND 
        L2.rightClassName = ('ClassRoom') AND 
        L2.leftToRightProperty = ('classRoom')
        
        LEFT JOIN ClassRoom CR ON 
        CR.id = L2.rightInstanceId
        
        -- join on the product
        LEFT JOIN Core_Relationship L3 ON 
        L3.leftClassName = ('OrderBoughtProduct') AND 
        L3.leftInstanceId = OBP.id AND 
        L3.rightClassName = ('Product') AND 
        L3.leftToRightProperty = ('product')
        
        LEFT JOIN Product P ON 
        P.id = L3.rightInstanceId
        
        WHERE 
        -- classroom date filters
        ";
        if(strlen($dateFrom)) {
            $sql .= "CR.startDate >= ('".date("Y-m-d H:i:s",strtotime($dateFrom))."') AND 
            ";
        }
        if(strlen($dateTo)) {
            $sql .= "CR.startDate <= ('".date("Y-m-d H:i:s",strtotime($dateTo))."') AND 
            ";
        }
        $sql .= "
        -- ignore no customer
        C.id > 0 AND 
        C.id IS NOT NULL AND 
        -- ignore no order
        O.id > 0 AND 
        O.id IS NOT NULL AND 
        -- classroom/combined products
        (
            P.type = ('classroom course') OR 
            P.type = ('combined course')
        ) AND 
        (
            -- partially paid
            OBP.orderPaymentStatus = 1 OR 
            -- not fully paid, ILA orders
            (O.`status` < 2 AND O.iLAOrder = 1)
        )
        ";

        $fn = "application/assets/reports/balance_payments/".uniqid().".csv";
        $fh = fopen($fn,"w");
        if(!$fh) {
            throw new Exception("Could not create the csv file");
        }

        fputcsv($fh,array(
            "customer id",
            "customer email",
            "order id",
            "code",
            "start date",
            "end date",
            "total due"
        ));

        $db = $this->Extorio()->getDbInstanceDefault();
        $rows = $db->getRowsIndices($sql);
        foreach ($rows as $row) {
            fputcsv($fh,$row);
        }

        fclose($fh);

        $this->output->data = $fn;gfds
    } */
<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Balance Payments</h4>
              <div class="table-responsive">
                <el-row style="margin-top:30px; margin-bottom: 10px">
                  <el-col :span="5">
                    <label class="control-label">Region:</label>
                    <br />
                    <el-select v-model="filters[1].value" placeholder="select region">
                      <el-option label="All" value="ALL"></el-option>
                      <el-option label="UK" value="TEFLORG"></el-option>
                      <el-option label="US" value="TEFLUS"></el-option>
                      <el-option label="EU" value="IRELAND"></el-option>
                    </el-select>
                  </el-col>

                  <el-col :span="7">
                    <label class="control-label">Select Date Range</label>
                    <br />
                    <el-date-picker
                      @change="getBalancePaymentsCsv"
                      v-model="filters[2].value"
                      type="daterange"
                      align="right"
                      range-separator="-"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                      :picker-options="pickerOptions1"
                    ></el-date-picker>
                    <br />
                    <el-button @click="balance()">Download Csv</el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
          <el-card>
            <div>
              <el-row>
                <el-col>
                  <data-tables-server
                    id="tables"
                    class="table-shopping"
                    style="width: 100%"
                    :data="balances"
                    :tool-bar="false"
                    :current-page="1"
                    :total="total"
                    :loading="loadingPayments"
                    :page-size="10"
                    @query-change="getBalancePayments"
                    :filters="filters"
                    :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
                  >
                    <el-table-column label="Customer Id" min-width="10">
                      <template slot-scope="props">
                        <span
                          v-for="(bought, index) in props.row.boughtProducts"
                          :key="index"
                        >{{bought.customer.id}}</span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Customer Email" min-width="10">
                      <template slot-scope="props">
                        <span
                          v-for="(bought, index) in props.row.boughtProducts"
                          :key="index"
                        >{{bought.customer.email}}</span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Order Id" min-width="10">
                      <template slot-scope="props">
                        <span
                          v-for="(bought, index) in props.row.boughtProducts"
                          :key="index"
                        >{{bought.orderId}}</span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Classroom Start" min-width="10">
                      <template slot-scope="props">
                        <span
                          v-for="(bought, index) in props.row.boughtProducts"
                          :key="index"
                        ><span v-if="bought.classRoom">{{bought.classRoom.startDate}}</span></span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Classroom End" min-width="10">
                      <template slot-scope="props">
                        <span
                          v-for="(bought, index) in props.row.boughtProducts"
                          :key="index"
                        ><span v-if="bought.classRoom">{{bought.classRoom.endDate}}</span></span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Venue Name" min-width="10">
                      <template slot-scope="props">
                        <span
                          v-for="(bought, index) in props.row.boughtProducts"
                          :key="index"
                        ><span v-if="bought.classRoom">{{bought.classRoom.venue.name}}</span></span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Venue Location" min-width="10">
                      <template slot-scope="props">
                        <span
                          v-for="(bought, index) in props.row.boughtProducts"
                          :key="index"
                        ><span v-if="bought.classRoom">{{bought.classRoom.venue.town}}</span></span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Total Due" min-width="10">
                      <template slot-scope="props">
                        <span>{{props.row.totalDue}}</span>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      balances: [],
      paymentsCsv: [],
      csvArr: [],
      aggregate: {},
      total: 0,
      loadingPayments: false,
      filters: [
        {
          value: "2",
          prop: "status"
        },
        {
          value: "ALL",
          prop: "productPriceLabel"
        },
        {
          value: [
            moment()
              .subtract(1, "months")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ],
          prop: "dateCreated"
        }
      ],
      url: null,
      pickerOptions1: {
        shortcuts: [
          {
            text: "Last 24 hours",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Two Weeks",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "1 year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    getBalancePayments(queryInfo) {
      if (queryInfo != undefined) {
        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = "asc_nulls_last";
        var orderProp = "startDate";

        (queryInfo.type === "page" ||
          queryInfo.type === "size" ||
          queryInfo.type === "sort") &&
          this.$message(
            `page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`
          );

        if (queryInfo.sort.order === "ascending") {
          orderDir = "asc_nulls_last";
        } else if (queryInfo.sort.order === "descending") {
          orderDir = "desc_nulls_last";
        } else {
        }
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }
      } else {
        var type = "init";
        var page = 1;
        var pageSize = 10;
        var orderDir = "asc_nulls_last";
        var orderProp = "startDate";
      }

      this.loadingPayments = true;
      // Format the dates to match the format in the database
      var startDate = moment(this.filters[2].value[0]).format("YYYY-MM-DD");
      var endDate = moment(this.filters[2].value[1]).format("YYYY-MM-DD");

      // Get the relevant data for the balance payments based on the orders that have a status of partially paid
      let query = gql`

        query MyQuery {
          Order(
            limit: ${pageSize}, 
            offset: ${(page - 1) * pageSize},
            where: {
              status: { _eq: "1" }
              boughtProducts: {
                _and: {
                  classRoom: {
                    _and: {
                      startDate: { _gte: "${startDate}" }
                      _and: { endDate: { _lte: "${endDate}" } }
                    }
                  }
                }
              }
            }
          )   { 
            boughtProducts {
              customer {
                  id
                  email  
                }
                orderId
                classRoom {
                  startDate
                  endDate
                  venue{
                    name
                    town
                  }
                }
                
              }
              totalDue
            
          }
          Order_aggregate(
            where: {
              status: { _eq: "1" }
              boughtProducts: {
                _and: {
                  classRoom: {
                    _and: {
                      startDate: { _gte: "${startDate}" }
                      _and: { endDate: { _lte: "${endDate}" } }
                    }
                  }
                }
              }
            }
          )  {
            aggregate {
              count
            }
          }
          
        }

    `;
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: query,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.balances = response.data.Order;
          this.aggregate = response.data.Order_aggregate.aggregate;
          this.total = response.data.Order_aggregate.aggregate.count;
          this.loadingPayments = false;
        });
    },
    getBalancePaymentsCsv() {
      var startDate = moment(this.filters[2].value[0]).format("YYYY-MM-DD");
      var endDate = moment(this.filters[2].value[1]).format("YYYY-MM-DD");

      let query = gql`
        query MyQuery {
          Order(
            where: {
              status: { _eq: "1" }
              boughtProducts: {
                _and: {
                  classRoom: {
                    _and: {
                      startDate: { _gte: "${startDate}" }
                      _and: { endDate: { _lte: "${endDate}" } }
                    }
                  }
                }
              }
            }
          ) {
            boughtProducts {
              customer {
                id
                email
              }
              orderId
              classRoom {
                startDate
                endDate
                venue{
                  name
                  town
                }
              }
            }
            totalDue
          }
        }
      `;

      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: query,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.paymentsCsv = response.data.Order;
        });
    },
    balance() {
      // Empty the array first in case it has data from a previous query
      this.csvArr = [];
      var payments = this.paymentsCsv;
      var sLen = this.paymentsCsv.length;
      // console.log(sLen);

      for (var i = 0; i < sLen; i++) {
        this.csvArr.push([
          payments[i].boughtProducts[0].customer.id,
          payments[i].boughtProducts[0].customer.email,
          payments[i].boughtProducts[0].orderId,
          payments[i].boughtProducts[0].classRoom.startDate,
          payments[i].boughtProducts[0].classRoom.endDate,
          payments[i].boughtProducts[0].classRoom.venue.name,
          payments[i].boughtProducts[0].classRoom.venue.town,
          payments[i].totalDue
        ]);
      }

      // console.log(this.csvArr);

      let csvContent =
        [
          [
            "Customer ID",
            "Customer Email",
            "Order ID",
            "Classroom StartDate",
            "Classroom EndDate",
            "Venue Name",
            "Venue Location",
            "Total Due"
          ]
        ] + "\r";

      this.csvArr.forEach(rowArray => {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });

      var fileURL = window.URL.createObjectURL(
        new Blob([csvContent], { type: "text/csv" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Balance_Payments.csv");
      document.body.appendChild(fileLink);
      fileLink.click();
    }
  },
  mounted() {
    this.getBalancePayments();
    this.getBalancePaymentsCsv();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Reports/BalancePayments.vue